import React, { useEffect } from 'react';
import { format as formatDate } from 'date-fns';
import { keyBy } from 'lodash';
import { Button } from 'reactstrap';

import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionFetch from '../hooks/useCollectionFetch';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import AdminPage from '../hocs/AdminPage';
import AdminEventHeader from '../AdminEventHeader';
import TenantLink from '../TenantLink';

const db = firebase.firestore();

export default AdminPage(function AdminEventEmailHistory(props) {
  const {
    user,
    match: {
      params: { eventId, historyId },
    },
    addBreadNavValues,
    history,
  } = props;

  const event = useDocumentSubscription(db.collection('events').doc(eventId), [eventId]);
  const emailHistory = useDocumentSubscription(
    event?.ref.collection('emailHistories').doc(historyId),
    [event, historyId]
  );

  const lectures = useCollectionFetch(event?.ref.collection('lectures'), [event]);
  const lecturesById = keyBy(lectures, 'id');

  // cancellationNotices の場合
  const cancellationNotices = useDocumentsFetch(
    emailHistory?.cancellationNoticeIds && event?.ref
      ? emailHistory.cancellationNoticeIds.map(id =>
          event.ref.collection('cancellationNotices').doc(id)
        )
      : [],
    [emailHistory, event]
  );

  // followers の場合
  const followers = useDocumentsFetch(
    emailHistory?.followerIds && emailHistory.followerIds.length > 0
      ? emailHistory.followerIds.map(id =>
          db.collection('eventLectureAddNotifications').doc(id)
        )
      : [],
    [emailHistory]
  );

  const isFollowerType = emailHistory?.type === 'eventFollower';
  const targetUsers = isFollowerType ? followers : cancellationNotices;
  const activeTab = isFollowerType ? 'followersEmailHistories' : 'emailHistories';

  useEffect(() => {
    addBreadNavValues({ event });
  }, [event]);

  return (
    event != null && emailHistory != null && (
      <div>
        <div className="admin-event-email-history container-fluid py-5 position-relative">
          <AdminEventHeader activeTab={activeTab} event={event} user={user} />
          <div className="bg-white p-4">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                </div>

                <div className="mb-4">
                  <div className="card">
                    <div className="card-body">
                      <h6 className="card-title">送信情報</h6>
                      <div className="row">
                        <div className="col-md-6">
                          <p><strong>送信日時:</strong> {emailHistory.createdAt.toDate().toLocaleString()}</p>
                          <p><strong>送信者:</strong> {emailHistory.createdBy.displayName}</p>
                        </div>
                        <div className="col-md-6">
                          <p><strong>件名:</strong> {emailHistory.subject}</p>
                          <p><strong>送信件数:</strong> {emailHistory.sentCount}件</p>
                        </div>
                      </div>
                      <div className="mt-3">
                        <p><strong>本文:</strong></p>
                        <div className="p-3 bg-light" style={{ whiteSpace: 'pre-line' }}>
                          {emailHistory.text}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <h6>送信対象者一覧 ({targetUsers.length}件)</h6>
                </div>
                {targetUsers.length > 0 ? (
                  <table className="table">
                    <thead className="thead-light text-center">
                      <tr>
                        {!isFollowerType && <th style={{ minWidth: 100 }}>レクチャー日</th>}
                        <th style={{ minWidth: 100 }}>アカウント</th>
                        <th style={{ minWidth: 100 }}>メールアドレス</th>
                        <th style={{ minWidth: 100 }}>{isFollowerType ? 'フォロー開始時間' : '登録時間'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {targetUsers.map((target) => {
                        const { id, createdBy, lectureId, createdAt } = target;
                        const lecture = lecturesById[lectureId];
                        return (
                          <tr key={id}>
                            {!isFollowerType && <td>{lecture?.date ? formatDate(lecture.date.toDate(), 'yyyy/MM/dd') : ''}</td>}
                            <td>
                              <TenantLink to={`/admin/users/${createdBy.uid}`}>{createdBy.displayName}</TenantLink>
                            </td>
                            <td>{createdBy.email}</td>
                            <td>{createdAt.toDate().toLocaleString()}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div>送信対象者の情報を取得できませんでした</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
});